import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { RoomEnvironment } from "three/examples/jsm/environments/RoomEnvironment";
import { SpinControls } from "./3D/SpinControls";
import { trackEvent } from "./analytics";

/**
 * @param {string} qrId
 * @param {boolean} isUsed
 */
const buildDeepLink = (qrId, isUsed) =>
  // OLD: Firebase Dynamic Link
  // `https://weedar.page.link/?link=https://www.weedar.io/loyalty/qr/${qrId}${
  //   isUsed ? "/redeemed" : ""
  // }&ibi=com.weel.ar&isi=1601307559&efr=1&apn=io.weedar.app`;
  `https://weedar.onelink.me/0vk8?af_xp=referral&pid=redemption_qr_code_scan&c=WDR_LINKS&af_dp=weedar://&af_sub1=qr&deep_link_value=wdr&deep_link_sub1=https://www.weedar.io/loyalty/qr/${qrId}${
    isUsed ? "/redeemed" : ""
  }`;

export const getIOsVersion = () => {
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isIOS) {
    const extract = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
    return [
      parseInt(extract[1] || 0, 10),
      parseInt(extract[2] || 0, 10),
      parseInt(extract[3] || 0, 10),
    ];
  }

  return [0, 0, 0];
};

export function displayData(data, qr, isOrder, isMultipleOrder, index = 0) {
  const brand = document.querySelector(".brand__name");
  const product = document.querySelector(".product__name");
  if (isOrder) {
    const nameSplited = data?.user?.name.split(" ");
    const nameFormatted =
      nameSplited[0] + " " + (nameSplited[1] ? nameSplited[1][0] + "." : "");
    const fee = document.querySelector(".fee__price");
    const totalPrice = document.querySelector(".total__price");
    const isPromo = !!data.details.find((detail) => detail?.product?.isPromo); // false = product $;
    const ordersData = document.querySelector(".multiple__total");
    const singleProductQty = document.querySelector(".multiple__dollar--count");
    const singleProductPrice = document.querySelector(
      ".multiple__dollar--price"
    );
    if (isMultipleOrder) {
      const customerInfo = document.querySelector(".multiple__text");
      const orderContainer = document.querySelector(".orders__wrapper");
      const template = document.querySelector(".order__template");
      const multipleOrderCustomerName = document.querySelector(
        ".multiple__info__name"
      );
      if (!isPromo)
        customerInfo.innerHTML = "Verify correct products and payment for";
      if (isPromo) customerInfo.innerHTML = "Verify correct products for";
      multipleOrderCustomerName.innerHTML = nameFormatted;
      data.details.forEach((details) => {
        const cloneTemplate = template.content.cloneNode(true);
        cloneTemplate.querySelector(".multiple__order--img").src =
          details?.product?.images[0]?.file?.url;
        cloneTemplate.querySelector(
          ".multiple__order__product--brand"
        ).innerHTML = data?.brand?.name;
        cloneTemplate.querySelector(
          ".multiple__order__product--gramm"
        ).innerHTML = `${details?.product?.gramWeight} G / ${details?.product?.ounceWeight} oz`;
        cloneTemplate.querySelector(
          ".multiple__order__product--name"
        ).innerHTML = details?.product?.name;
        cloneTemplate.querySelector(".multiple__order__info--count").innerHTML =
          "x" + details?.quantity;
        cloneTemplate.querySelector(".multiple__order__info--price").innerHTML =
          details?.product?.price && !isPromo
            ? "$" + details?.product?.price
            : "";
        orderContainer.appendChild(cloneTemplate);
      });
    } else {
      const headerText = document.querySelector(".header__text");
      const grams = document.querySelector(".product__gram");
      const customerName = document.querySelector(".header__info__name");
      if (isPromo) headerText.innerHTML = "Verify correct products for";
      if (!isPromo)
        headerText.innerHTML = "Verify correct products and payment for";
      customerName.innerHTML = nameFormatted;
      brand.innerHTML = data?.brand?.name;
      product.innerHTML = data?.details[index].product?.name;
      grams.innerHTML = `${data?.details[index].product?.gramWeight} G / ${data?.details[index].product?.ounceWeight} oz`;
      if (!isPromo) {
        singleProductQty.innerHTML = "x" + data?.details[index]?.quantity;
        singleProductPrice.innerHTML =
          "$" + data?.details[index]?.product?.price;
      }
    }

    document
      .querySelector(".multiple__total")
      .classList.remove("display__none");
    if (!isPromo) {
      totalPrice.innerHTML = "$" + data?.sumDollar;
      if (isMultipleOrder) {
        !data?.deliveryFee &&
          document
            .querySelector(".delivery__fee")
            .classList.add("display__none");
      } else {
        !data?.deliveryFee &&
          document
            .querySelectorAll(".delivery__fee")[1]
            .classList.add("display__none");
      }
      fee.innerHTML = "$" + data?.deliveryFee;
    } else {
      ordersData.classList.add("display__none");
    }
    return;
  }

  const isAndroid = /Android/.test(navigator.userAgent);
  const isDesktopPlatform = isDesktop();
  const desktopLink = "https://apps.apple.com/us/app/weelar/id1601307559";
  const redeemPoints = document.querySelector(".buttons__redeem--points");
  const redeem = document.querySelector(".buttons__redeem");
  const coa = document.querySelector(".buttons__coa");
  const googleDocsView = "https://docs.google.com/gview?url=";
  const thc = document.querySelector(".thc");
  const thcPercent = document.querySelector(".thc__percent");
  const gram = document.querySelector(".gram__weigh");
  const brandImg = document.querySelector(".logo--img");

  redeemPoints.innerHTML = data.brandPoints;
  product.innerHTML = data?.name;
  const thcNumber = +data?.thc;
  const grammNumber = +data?.gramWeight;
  const ounceWeight = +data?.ounceWeight;
  const isFallbackQR = data?.isFallbackQrCode;

  const withWeight = grammNumber || ounceWeight;
  if (grammNumber && ounceWeight) {
    gram.innerHTML = grammNumber + " G / " + ounceWeight + " oz";
  } else if (grammNumber) {
    gram.innerHTML = grammNumber + " G";
  } else if (ounceWeight) {
    gram.innerHTML = ounceWeight + " oz";
  } else {
    gram.style.visibility = "hidden";
    gram.style.display = "none";
  }

  if (thcNumber > 0) {
    thcPercent.innerHTML = thcNumber.toFixed(2) + " %";
    if(!withWeight && !isFallbackQR) {
      thc.classList.add("thc--no-weight");
    }
  } else {
    thc.style.visibility = "hidden";
  }

  if (!isFallbackQR) {
    brandImg.src = data?.brand?.authenticLogo?.url || data?.brand?.logo?.url;
  } else {
    gram.innerHTML = "";
    thcPercent.style.visibility = "hidden";
    gram.style.visibility = "hidden";
    thc.style.visibility = "visible";
    thc.classList.add("thc--no-weight");
    document.querySelector(".auth--title").innerHTML = "Earn random rewards";
    thc.innerHTML =
      "It's your chance to get random points from brands on the platform! Thank you for being a loyal customer! Enjoy!";
  }

  if (data?.coaStatusDocument?.url) {
    coa.classList.remove("display__none");
    coa.href = isAndroid
      ? googleDocsView + data.coaStatusDocument.url
      : data.coaStatusDocument.url;
  }
  if (qr) {
    // const deepLink = `https://weedar.page.link/?link=https://www.weedar.io/loyalty/qr/${qr}${
    //   data.used ? "/redeemed" : ""
    // }&ibi=com.weel.ar&isi=1601307559&efr=1&apn=io.weedar.app`;

    const deepLink = buildDeepLink(qr, data.used);
    if (data.used) redeem.innerHTML = "View brand";
    isDesktopPlatform ? (redeem.href = desktopLink) : (redeem.href = deepLink);
  }
}

function isDesktop() {
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isAndroid = /Android/.test(navigator.userAgent);
  return !isIOS && !isAndroid;
}

export function createContainerForModel() {
  const containerRefCreate = document.createElement("div");
  containerRefCreate.classList.add("box2", "opacityZero");
  containerRefCreate.id = "containerRef";
  document.querySelector(".order").appendChild(containerRefCreate);
}

const POSITION_Y_OFFSET = 0.1;
const PIVOT_SIZE = 0.25;
const PIVOT_OPACITY = 0.5;
const PIVOT_POSITION_Y_OFFSET = 0.15;
const PIVOT_ROTATION_X = 0.3;
const CUBE_SCALE = 0.8;
const CUBE_ANIMATION_DURATION = 0.4;
const CUBE_ANIMATION_POSITION_OFFSET = 0.14;
/**
 * Runs the Three.js animation with the provided parameters.
 *
 * @param {string} url - The URL of the 3D model to load.
 * @param {Object} position - The position of the camera.
 * @param {Object} threeVector - The vector for scaling and positioning the 3D model.
 * @param {boolean} isAuthentic - Flag indicating if the model is authentic.
 */
export async function runThreeJs(
  url,
  position,
  threeVector,
  isAuthentic = false
) {
  const onOpenHideElements = document.querySelectorAll(".onOpen");
  const containerRef = document.getElementById("containerRef");
  const aspect = window.innerWidth / window.innerHeight;

  const camera = new THREE.PerspectiveCamera(45, aspect, POSITION_Y_OFFSET, 20);
  camera.position.set(position.x, position.y, position.z);

  const scene = new THREE.Scene();
  const nftModelGlb = await new GLTFLoader().loadAsync(url);
  const obj = nftModelGlb.scene;

  obj.position.y += POSITION_Y_OFFSET;

  scaleToFit(
    nftModelGlb.scene,
    new THREE.Vector3(threeVector.x, threeVector.y, threeVector.z)
  );

  const box = new THREE.Box3().setFromObject(obj);
  const center = box.getCenter(new THREE.Vector3(threeVector));
  const boundingSphere = box.getBoundingSphere(new THREE.Sphere());

  const pivot = new THREE.Mesh(
    new THREE.BoxGeometry(PIVOT_SIZE, PIVOT_SIZE, PIVOT_SIZE),
    new THREE.MeshBasicMaterial({
      color: 0xff0000,
      transparent: true,
      visible: false,
      opacity: PIVOT_OPACITY,
    })
  );

  scene.add(pivot);
  pivot.add(obj);

  const cube = pivot;
  pivot.position.y += PIVOT_POSITION_Y_OFFSET;
  pivot.rotation.x = PIVOT_ROTATION_X;
  obj.position.y -= center.y;

  const mixer = new THREE.AnimationMixer(nftModelGlb.scene);

  let aminStart,
    animEnd,
    open,
    close,
    animationState = "close",
    animationFrame,
    onClick;
  const checkAnimationFinish = (anim, cb) => {
    anim.isRunning()
      ? setTimeout(() => checkAnimationFinish(anim, cb), 3)
      : cb();
  };

  const cubeMixer = new THREE.AnimationMixer(cube);
  const closeTrackPosition = new THREE.VectorKeyframeTrack(
    ".position",
    [0, CUBE_ANIMATION_DURATION],
    [
      cube.position.x,
      cube.position.y,
      cube.position.z,
      cube.position.x,
      cube.position.y - 0.04,
      0,
    ]
  );
  const closeTrackScale = new THREE.VectorKeyframeTrack(
    ".scale",
    [0, CUBE_ANIMATION_DURATION],
    [CUBE_SCALE, CUBE_SCALE, CUBE_SCALE, 1, 1, 1]
  );
  const closeAnimationClip = new THREE.AnimationClip("Close", -1, [
    closeTrackPosition,
    closeTrackScale,
  ]);

  const closeAnimationActions = cubeMixer.clipAction(closeAnimationClip);
  closeAnimationActions.loop = THREE.LoopOnce;
  closeAnimationActions.clampWhenFinished = true;

  const openTrackPosition = new THREE.VectorKeyframeTrack(
    ".position",
    [0, CUBE_ANIMATION_DURATION],
    [
      cube.position.x,
      cube.position.y,
      cube.position.z,
      cube.position.x,
      cube.position.y + 0.04,
      0,
    ]
  );

  const openTrackScale = new THREE.VectorKeyframeTrack(
    ".scale",
    [0, CUBE_ANIMATION_DURATION],
    [1, 1, 1, CUBE_SCALE, CUBE_SCALE, CUBE_SCALE]
  );

  const openAnimationClip = new THREE.AnimationClip("open", -1, [
    openTrackPosition,
    openTrackScale,
  ]);

  const openAnimationActions = cubeMixer.clipAction(openAnimationClip);
  openAnimationActions.loop = THREE.LoopOnce;
  openAnimationActions.clampWhenFinished = true;

  nftModelGlb.animations.forEach((clip) => {
    const anim = mixer.clipAction(clip);

    switch (anim._clip.name) {
      case "start":
      case "sart": // ?????
        aminStart = anim;
        open = () => {
          trackEvent("authentic_product_model_full_screen_open");
          if (animationState === "running") return;
          onOpenHideElements.forEach((el) => el.classList.add("hide"));
          if (isAuthentic) {
            camera.position.set(
              // eslint-disable-next-line no-loss-of-precision
              0.0028091313521602023,
              // eslint-disable-next-line no-loss-of-precision
              0.17605276630822155,
              0.7428539023616042
            );
          }
          animationState = "running";
          animEnd?.stop();
          closeAnimationActions.stop();
          openAnimationActions.play();
          cube.rotation.set(0, 0, 0);
          setTimeout(() => {
            anim.clampWhenFinished = true;
            anim.loop = THREE.LoopOnce;
            anim.paused = false;
            anim.play();
            setTimeout(() => {
              checkAnimationFinish(anim, () => {
                animationState = "open";
              });
            }, anim._clip.duration * 1000);
            onOpenHideElements.forEach((el) => el.classList.add("displayNone"));
          }, 100);
        };
        break;
      case "end":
        animEnd = anim;
        close = () => {
          if (animationState === "running") return;
          animationState = "running";
          aminStart.stop();
          anim.clampWhenFinished = true;
          anim.loop = THREE.LoopOnce;
          anim.paused = false;
          anim.play();
          onOpenHideElements.forEach((el) =>
            el.classList.remove("displayNone")
          );
          setTimeout(() => {
            closeAnimationActions.play();
            cube.rotation.set(0, 0, 0);
            checkAnimationFinish(anim, () => {
              anim.stop();
              animationState = "close";
              onOpenHideElements.forEach((el) => el.classList.remove("hide"));
              if (isAuthentic) {
                camera.position.set(
                  // eslint-disable-next-line no-loss-of-precision
                  position.x,
                  position.y,
                  position.z
                );
              }
            });
          }, anim._clip.duration * 1000 - 500);
          trackEvent("authentic_product_model_full_screen_close");
        };
        break;
    }
  });

  onClick = (event) => {
    const getCoordinate = () =>
      "changedTouches" in event ? event?.changedTouches?.[0] : event;

    const x = (getCoordinate().pageX / window.innerWidth) * 2 - 1;
    const y = -(getCoordinate().pageY / window.innerHeight) * 2 + 1;
    const rayCaster = new THREE.Raycaster();
    rayCaster.setFromCamera({ x, y }, camera);
    const intersects = rayCaster.intersectObjects([cube], true);

    !!intersects[0] &&
      (animationState === "close"
        ? open()
        : animationState === "open"
        ? close()
        : null);
  };

  const clock = new THREE.Clock();
  const resourceTracker = ResourceTracker();

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const webGLRendererConfig = {
    antialias: true,
    alpha: true,
    powerPreference: isSafari ? "high-performance" : undefined,
  };
  const renderer = new THREE.WebGLRenderer(webGLRendererConfig);
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 0.8;
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.outputEncoding = THREE.sRGBEncoding; // @deprecated — Use WebGLRenderer.outputColorSpace .outputColorSpace in three.js r152+.
  containerRef.appendChild(renderer.domElement);
  const canvas = containerRef.querySelector("canvas");

  swipeEventModel(canvas);

  const pmremGenerator = new THREE.PMREMGenerator(renderer);
  pmremGenerator.compileEquirectangularShader();
  scene.environment = pmremGenerator.fromScene(
    new RoomEnvironment(),
    0.04
  ).texture;

  const spinControl = new SpinControls(
    cube,
    boundingSphere.radius,
    camera,
    renderer.domElement,
    onClick
  );
  resourceTracker.track(scene);

  const onWindowResize = () => {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    spinControl?.onWindowResize();
    renderer.setSize(window.innerWidth, window.innerHeight);
  };
  function animate() {
    animationFrame = requestAnimationFrame(animate);
    const delta = clock.getDelta();
    if (mixer) mixer.update(delta);
    if (cubeMixer) cubeMixer.update(delta);
    if (spinControl) spinControl.update();

    if (animationState === "close") {
      const rangeMin = 0.14;
      const rangeMax = 0.17;
      const range = rangeMax - rangeMin;
      const value = 0.5 * Math.sin(Date.now() * 0.00115);
      pivot.position.y = ((value + 1) / 2) * range + rangeMin;
    }

    renderer.render(scene, camera);
  }

  animate();

  initOnCloseButtonClickHandler(
    isAuthentic,
    animationFrame,
    clock,
    resourceTracker,
    renderer,
    onWindowResize
  );

  function swipeEventModel(canvas) {
    canvas.addEventListener("touchstart", (event) => {
      let mouseDown = true;
      let initialMouseX = event.touches[0].clientX;
      let initialMouseY = event.touches[0].clientY;
      let deltaX = 0;
      let deltaY = 0;
      canvas.addEventListener("touchmove", (event) => {
        if (mouseDown) {
          deltaX = initialMouseX - event.touches[0].clientX;
          deltaY = initialMouseY - event.touches[0].clientY;
        }
      });
      canvas.addEventListener("touchend", (event) => {
        mouseDown = false;
        if (deltaX != 0 || deltaY != 0) {
          if (animationState === "close") {
            trackEvent("authentic_product_model_swipe");
          }
          if (animationState === "open") {
            trackEvent("authentic_product_model_full_screen_swipe");
          }
        }
        deltaX = 0;
        deltaY = 0;
      });
    });

    canvas.addEventListener("mousedown", (event) => {
      let mouseDown = true;
      let initialMouseX = event.clientX;
      let initialMouseY = event.clientY;
      let deltaX = 0;
      let deltaY = 0;
      canvas.addEventListener("mousemove", (event) => {
        if (mouseDown) {
          deltaX = initialMouseX - event.clientX;
          deltaY = initialMouseY - event.clientY;
        }
      });
      canvas.addEventListener("mouseup", (event) => {
        mouseDown = false;
        if (deltaX != 0 || deltaY != 0) {
          if (animationState === "close") {
            trackEvent("authentic_product_model_swipe");
          }
          if (animationState === "open") {
            trackEvent("authentic_product_model_full_screen_swipe");
          }
        }
        deltaX = 0;
        deltaY = 0;
      });
    });
  }
  window.removeEventListener("resize", onWindowResize, false);
}

function initOnCloseButtonClickHandler(
  isAuthentic,
  animationFrame,
  clock,
  resourceTracker,
  renderer,
  onWindowResize
) {
  if (!isAuthentic) {
    const closeBtn = document.querySelector(".close");
    closeBtn.addEventListener("click", () => {
      cancelAnimationFrame(animationFrame);
      clock.stop();
      resourceTracker.dispose();
      renderer.dispose();
      renderer.forceContextLoss();
      window.removeEventListener("resize", onWindowResize, false);
      const sceneDiv = document.getElementById("containerRef");
      if (sceneDiv) {
        sceneDiv.remove();
      }
    });
  }
}

function scaleToFit(obj, bound) {
  let box = new THREE.Box3().setFromObject(obj);
  let size = new THREE.Vector3();
  box.getSize(size);
  let vScale = new THREE.Vector3().copy(bound).divide(size);
  let scale = Math.min(vScale.x, Math.min(vScale.y, vScale.z));
  obj.scale.setScalar(scale);
}

const ResourceTracker = () => {
  // eslint-disable-next-line no-undef
  let resources = new Set();
  const track = (resource) => {
    if (!resource) {
      return resource;
    }
    if (Array.isArray(resource)) {
      resource.forEach((resource) => track(resource));
      return resource;
    }
    if (resource.dispose || resource instanceof THREE.Object3D) {
      resources.add(resource);
    }

    if (resource instanceof THREE.Object3D) {
      track(resource.geometry);
      track(resource.material);
      track(resource.children);
    } else if (resource instanceof THREE.Material) {
      for (const value of Object.values(resource)) {
        if (value instanceof THREE.Texture) {
          track(value);
        }
      }
      if (resource.uniforms) {
        for (const uniform of Object.values(resource.uniforms)) {
          if (uniform) {
            const uniformValue = uniform.value;
            if (
              uniformValue instanceof THREE.Texture ||
              Array.isArray(uniformValue)
            ) {
              track(uniformValue);
            }
          }
        }
      }
    }
    return resource;
  };

  const dispose = () => {
    for (const resource of resources) {
      if (resource instanceof THREE.Object3D) {
        if (resource.parent) {
          resource.parent.remove(resource);
        }
      }
      if (resource.dispose && resource.type !== "Scene") {
        resource.dispose();
      }
    }
    resources.clear();
  };

  return {
    track,
    dispose,
  };
};